import { jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { StoreLocatorWidget } from "../StoreLocatorWidget/index.js";
function StoreLocatorPart({
  part,
  apiBaseUrl
}) {
  if (isCallState(part.state)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-loading", style: { padding: "12px 0", fontSize: "14px" }, children: "Finding nearby stores..." });
  }
  if (isOutputState(part.state) && part.output) {
    if (part.output.error) {
      return null;
    }
    if (part.output.isOnlineOnly) {
      return null;
    }
    if (part.output.hasStores && part.output.stacklineSku) {
      return /* @__PURE__ */ jsx(
        StoreLocatorWidget,
        {
          stacklineSku: part.output.stacklineSku,
          apiUrl: apiBaseUrl
        }
      );
    }
    return null;
  }
  return null;
}
export {
  StoreLocatorPart
};
//# sourceMappingURL=StoreLocatorPart.js.map
